document.addEventListener("DOMContentLoaded", function () {
  const maxOffset = 80; // Maximum movement limit in pixels
  let lastScrollY = window.scrollY;

  // Select left and right images
  const leftImages = document.querySelectorAll(".accompagnement_header-images-left");

  const rightImages = document.querySelectorAll(".accompagnement_header-images-right");

  window.addEventListener("scroll", () => {
    let scrollDirection = window.scrollY > lastScrollY ? 1 : -1; // 1 for down, -1 for up
    lastScrollY = window.scrollY;
    // console.log(lastScrollY);

    // Move left images to the left, ensuring they never go positive
    leftImages.forEach((img) => {
      let currentOffset = parseFloat(img.dataset.offset || 0);
      let newOffset = currentOffset - scrollDirection * 2; // Move left (-)

      if (lastScrollY === 0) {
        newOffset = 0;
      } else {
        // Ensure it stays within the range of 0 (original) to -maxOffset
        newOffset = Math.max(-maxOffset, Math.min(0, newOffset));
      }

      img.style.transform = `translateX(${newOffset}px)`;
      img.dataset.offset = newOffset;
    });

    // Move right images to the right, ensuring they never go negative
    rightImages.forEach((img) => {
      let currentOffset = parseFloat(img.dataset.offset || 0);
      let newOffset = currentOffset + scrollDirection * 2; // Move right (+)

      // Ensure it stays within the range of 0 (original) to maxOffset
      newOffset = Math.min(maxOffset, Math.max(0, newOffset));

      img.style.transform = `translateX(${newOffset}px)`;
      img.dataset.offset = newOffset;
    });
  });
});
